import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-online-support",
  templateUrl: "./online-support.component.html",
  styleUrls: ["./online-support.component.css"],
})
export class OnlineSupportComponent implements OnInit {
  chatUrl: SafeResourceUrl;
  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.chatUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      "https://webchat.botframework.com/embed/SampleHelloBot_Test?s=ZUOE8qyfTuw.cwA.7tc.LC4tRKMmx0RmDIF3u3jO_K5BAOQYLA9WkNNlYcZzUpI"
    );
    console.log(this.chatUrl);
  }
}
